import React from 'react';
import { Grid, Stack } from '@mui/material';
import MaterialTypography from '../../../../components/MaterialTypography';
import MaterialInput from '../../../../components/MaterialInput';
import MaterialDatePicker from '../../../../components/MaterialDatePicker';

const ProjectDetails = ({ formData, handleChange, handleDateChange }) => {
    return (
        <Grid container spacing={2}>
            <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                <Stack spacing={1}>
                    <MaterialTypography variant="caption" fontWeight="bold">Project Name</MaterialTypography>
                    <MaterialInput size="small" name="projectName" value={formData.projectName} onChange={handleChange} placeholder="Enter Project Name" fullWidth />
                </Stack>
            </Grid>
            <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                <Stack spacing={1}>
                    <MaterialTypography variant="caption" fontWeight="bold">Application Type</MaterialTypography>
                    <MaterialInput size="small" name="applicationType" value={formData.applicationType} onChange={handleChange} placeholder="Enter Application Type" fullWidth />
                </Stack>
            </Grid>
            <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                <Stack spacing={1}>
                    <MaterialTypography variant="caption" fontWeight="bold">Modules Covered</MaterialTypography>
                    <MaterialInput size="small" name="modulesCovered" value={formData.modulesCovered} onChange={handleChange} placeholder="Enter Modules Covered" fullWidth />
                </Stack>
            </Grid>
            <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                <Stack spacing={1}>
                    <MaterialTypography variant="caption" fontWeight="bold">Developing release Document Version</MaterialTypography>
                    <MaterialInput size="small" name="releaseDocVersion" value={formData.releaseDocVersion} onChange={handleChange} placeholder="Enter Version" fullWidth />
                </Stack>
            </Grid>
            <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                <Stack spacing={1}>
                    <MaterialTypography variant="caption" fontWeight="bold">Application Version</MaterialTypography>
                    <MaterialInput size="small" name="applicationVersion" value={formData.applicationVersion} onChange={handleChange} placeholder="Enter Application Version" fullWidth />
                </Stack>
            </Grid>
            <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                <Stack spacing={1}>
                    <MaterialTypography variant="caption" fontWeight="bold">Prepared By</MaterialTypography>
                    <MaterialInput size="small" name="preparedBy" value={formData.preparedBy} onChange={handleChange} placeholder="Enter Name" fullWidth />
                </Stack>
            </Grid>
            <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                <Stack spacing={1}>
                    <MaterialTypography variant="caption" fontWeight="bold">Test Cycle Completion Date</MaterialTypography>
                    <MaterialDatePicker size="small" onChange={handleDateChange} value={formData.testCycleDate} placeholder="Select Date" />
                </Stack>
            </Grid>
        </Grid>
    );
};

export default ProjectDetails;
